module.exports = __webpack_public_path__ + "img/reach-save.baf4924c.jpg";